import api from "./api.config";
import { API_CLIENT_ID, API_CLIENT_SECRET } from "./constants";
const login = (username, password) => {
    return api
        .post(`/oauth/token`, {
            "grant_type": "password",
            "client_id": API_CLIENT_ID,
            "client_secret": API_CLIENT_SECRET,
            "username": username,
            "password": password,
            "scope": "",
            "role": "admin"
        })
        .then((response) => {
            return response.data;
        });
};

const AuthService = {
    login
};

export default AuthService;